import { makeStyles } from '@material-ui/core';

export const getProposalPreviewDefaultInvestmentCostsEnergyCostsStyles =
  makeStyles(() => ({
    electricityCostsWithPVSystem: {
      paddingBottom: '7mm',
    },
  }));
